const AutomatedShowingsStyles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '80px 20px',
    backgroundColor: 'transparent', // Fully transparent background
    width: '100%',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconImage: {
    width: '100%',
    maxWidth: '250px', // Adjusted to match visual layout
  },
  textContainer: {
    textAlign: 'left',
    maxWidth: '700px',
  },
  title: {
    fontWeight: 'bold',
    fontSize: '1.8rem',
    color: '#000',
    marginBottom: '20px',
  },
  description: {
    fontSize: '1.2rem',
    marginTop: '10px',
    lineHeight: '1.6',
    color: '#333',
  },
  highlight: {
    fontWeight: 'bold',
    color: '#81c241', // Matches theme for key highlights
  },
  list: {
    paddingLeft: '15px',
  },
  listItem: {
    fontSize: '1.1rem',
    color: '#333',
    marginBottom: '10px',
  },
  boldText: {
    fontWeight: 'bold',
  },
};

export default AutomatedShowingsStyles;
